import {
  CheckBox,
  FieldSet,
  FormContext,
  FormState,
  FormValues,
  InfoBlockLayout,
  InfoBlockStatus,
  Select,
} from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { Settings, SettingsContext } from "../../console/SettingsContext";
import { backupRetentionPeriods, backupSlots, getBackUpScheduleTimeRange } from "../../helpers/resourceHelper";
import { utc } from "../../helpers/timeHelper";

export const GROUP_MANAGEMENT = "management";

export enum Fields {
  Backups = "databaseDetails.dbBackupConfig.autoBackupEnabled",
  RetentionPeriod = "databaseDetails.dbBackupConfig.recoveryWindowInDays",
  Scheduling = "databaseDetails.dbBackupConfig.autoBackupWindow",
}

export enum FieldTestIds {
  Backups = "autoBackupEnabled",
  RetentionPeriod = "recoveryWindowInDays",
  Scheduling = "autoBackupWindow",
}

export const ManagementTabContent = (): JSX.Element => {
  const { locale } = React.useContext<Settings>(SettingsContext);
  const [showBackupOptions, setShowBackupOptions] = React.useState(true);
  const form: FormState = React.useContext(FormContext);
  const [defaultBackupSchedule, setDefaultBackupSchedule] = React.useState<string>();
  const [defaultRetentionPeriod,
    setDefaultRetentionPeriod] = React.useState(backupRetentionPeriods.thirtyDaysPeriod.toString());
  const info = {
    messageType: InfoBlockStatus.INFO,
    message: Messages.createExaDb.managementTab.info.backupInfo(),
    infoLayout: InfoBlockLayout.Compact,

  };
  const onChangeShowBackUpOptions = (value: boolean): void => {
    setShowBackupOptions(value);
    if (value) {
      const formValues: FormValues = form.getGroupValues(GROUP_MANAGEMENT);
      setDefaultRetentionPeriod(formValues[Fields.RetentionPeriod]?.length > 0
        ? formValues[Fields.RetentionPeriod]?.[0].id
        : defaultRetentionPeriod);
      setDefaultBackupSchedule(formValues[Fields.Scheduling]?.length > 0
        ? formValues[Fields.Scheduling]?.[0].id : undefined);
    }
  };

  const retentionOptions = Object.values(backupRetentionPeriods).map(period => ({
    id: `${period}`,
    text: `${period} ${Messages.common.days()}`,
  }));

  const scheduleOptions = backupSlots.map(schedule => ({
    id: schedule.id,
    text: getBackUpScheduleTimeRange(schedule.id, locale),
  }));

  return (
    <FieldSet
      header={Messages.createExaDb.managementTab.sectionTitles.backupHeader()}
    >
      <CheckBox
        testId={FieldTestIds.Backups}
        defaultValue={showBackupOptions}
        statusInfo={info}
        fieldName={Fields.Backups}
        label={Messages.labels.enableAutomaticBackups()}
        onChange={value => {
          onChangeShowBackUpOptions(value);
        }}
      />
      {showBackupOptions && (
        <>
          <Select
            testId={FieldTestIds.RetentionPeriod}
            defaultValue={[defaultRetentionPeriod]}
            required
            fieldName={Fields.RetentionPeriod}
            label={Messages.labels.backupRetentionPeriod()}
            options={retentionOptions}
            hideSearchBox
          />
          <Select
            testId={FieldTestIds.Scheduling}
            defaultValue={defaultBackupSchedule ? [defaultBackupSchedule] : undefined}
            required
            fieldName={Fields.Scheduling}
            label={`${Messages.labels.backupScheduling()} (${utc})`}
            options={scheduleOptions}
            hideSearchBox
          />
        </>
      )}
    </FieldSet>
  );
};
